import {
  getFlightSearchForAdd,
  getFlightSearchForUpdate,
  getVendorSearchForAdd,
  getVendorSearchForUpdate,
} from "app/services/vendorService";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";

export default function VendorAndCarrierSearch({
  setSelected,
  selected,
  type,
  setFieldValue,
  touched,
  errors,
  edit,
  userGroupId,
  value,
}) {
  const [allVendor, setAllVendor] = useState([]);
  const loadOptions = async (inputValue) => {
    if (!inputValue) return [];

    const updateReq = inputValue
      ? `?searchText=${inputValue}&UserGroupId=${userGroupId}`
      : "";
    if (type === "vendor") {
      const response =
        edit == false
          ? await getVendorSearchForAdd(inputValue)
          : await getVendorSearchForUpdate(updateReq);
      const vendors = response.data.data || [];
      return vendors.map((vendor) => ({
        label: vendor.supplierName,
        value: vendor.id,
      }));
    } else {
      const response =
        edit == false
          ? await getFlightSearchForAdd(inputValue)
          : await getFlightSearchForUpdate(updateReq);

      const flights = response.data.data || [];
      return flights.map((flight) => ({
        label: flight.carrierName,
        value: flight.id,
      }));
    }
  };

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);

    if (type === "vendor") {
      setFieldValue("supplierId", selectedOption ? selectedOption.value : 0);
    } else {
      // debugger;
      setFieldValue(
        "carrierIdList",
        selectedOption ? selectedOption.map((opt) => opt.value) : []
      );
    }
  };

  useEffect(() => {
    const fetchSearch = async () => {
      const { data } = await getVendorSearchForAdd(""); // Fetch all countries at once
      if (data?.data?.length > 0) {
        setAllVendor(data.data);
      }
    };

    fetchSearch(); // Call API only once
  }, []);

  // Set selected value when `value` changes
  useEffect(() => {
    if (value && allVendor.length > 0) {
      const selected = allVendor.find((item) => item.id == value);
      if (selected) {
        setSelected({
          label: selected.supplierName,
          value: selected.id,
        });
        setFieldValue("supplierId", selected ? selected.id : 0);
      }
    }
  }, [value, allVendor]);

  return (
    <div>
      <AsyncSelect
        isMulti={type !== "vendor"}
        cacheOptions
        defaultOptions
        value={selected}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder={
          type === "vendor" ? "Select Vendor..." : "Select Carrier..."
        }
        name={type === "vendor" ? "supplierId" : "carrierIdList"}
      />
      {touched[type === "vendor" ? "supplierId" : "carrierIdList"] &&
        errors[type === "vendor" ? "supplierId" : "carrierIdList"] && (
          <div className="text-danger">
            {errors[type === "vendor" ? "supplierId" : "carrierIdList"]}
          </div>
        )}
    </div>
  );
}
